import api from './api';

export async function fetchSocialLinks() {
  const response = await api.get('/get-social-links');
  return response?.data?.dataset?.data || {};
}
